/**
 * Helper function for changing operation status with authentication
 * Centralizes the status change logic across all modals
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const changeOperationStatus = async (operationId, newStatus, additionalData = {}) => {
  const payload = {
    new_status: newStatus,
    validate_requirements: false,
    ...additionalData
  };
  
  const response = await axios.post(
    `${API}/operation-status/${operationId}/change`,
    payload,
    {
      headers: {
        'Authorization': 'Bearer cookie-auth',
        'Content-Type': 'application/json'
      }
    }
  );
  
  return response.data;
};

export const uploadDocument = async (operationId, documentType, file) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('documentType', documentType);  // Corrigé: documentType au lieu de document_type
  
  const response = await axios.post(
    `${API}/operations/${operationId}/documents`,  // Corrigé: utilise la bonne route
    formData,
    {
      headers: {
        'Authorization': 'Bearer cookie-auth',
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  
  return response.data;
};
